<template>
  <div>
    <user-detail-title
      first-bread="产品标签"
      second-bread="产品标签添加"
      first-url="/user/tag"
      title-name="产品标签添加"
    ></user-detail-title>
    <user-detail-base style="height: 81vh;"
    >
      <el-form label-position="left" label-width="100px">
        <el-form-item label="名称">
          <el-input v-model="Alist.name" ></el-input>
        </el-form-item>
        <el-form-item label="logo">
          <el-upload action="/api/photo/uploadFile" :on-success="GetUrlList">
            <el-button slot="trigger" size="small" type="primary">选取图片</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="产品分类">
          <el-select v-model="Alist.type" placeholder="请选择">
            <el-tree :data="Large"
                     node-key="id"
                     :props="defaultProps"
            >
              <div class="" slot-scope="{ node, data }" >
                <el-option  :label="data.name" :value="data.id"></el-option>
              </div>
            </el-tree>
          </el-select>
        </el-form-item>
        <el-form-item label="产品所属标签">
          <el-select multiple  v-model="Alist.superLabelId" placeholder="请选择">
            <el-option
              v-for="item in Small"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-button @click="handleAdd">添加</el-button>
      </el-form>
    </user-detail-base>
  </div>
</template>

<script>
  import UserDetailTitle from "../Common/UserDetailTitle";
  import UserDetailBase from "../Common/UserDetailBase";
  export default {
    name: "TagAdd",
    components: {UserDetailBase, UserDetailTitle},
    data(){
      return{
        Large:null,
        Small:null,
        defaultProps:{
          children: 'childClassify',
          label: 'name'
        },
        Alist: {
          'name':null,
          'type': null,
          'logoUrl':null,
          'superLabelId':null,
        },//表示Add添加的数据
      }
    },
    created() {
      this.GetLarge()
    },
    watch:{
      'Alist.type'(id){
        this.GetSmall(id)
      }
    },
    methods:{
      GetUrlList(file){
        this.Alist.logoUrl=file.data;
      },
      GetLarge(){
        this.$axios.get('/api/productClassify/getTree').then(res=>{

          this.Large=res.data.data;
        })
      },
      GetSmall(id){
        this.$axios.get('/api/tag/getLabelListByClass',{params:{
            classId:id,
          }}).then(res=>{

          this.Small=res.data.data
        })
      },
      handleAdd(){
        if ( this.Alist.type && this.Alist.superLabelId){
          if (this.Alist.name || this.Alist.logoUrl){
            this.$axios.post('/api/tag/add',this.Alist).then(res=>{
              if(res.data.success == true){
                this.Alist= {
                  'name':null,
                  'type': null,
                  'logoUrl':null,
                  'superLabelId':null,
                }//表示Add添加的数据,
                this.$message({
                  message:'添加成功',
                  type:'success'
                })
              }
            })
          }
          else {
            this.$message.warning('请选择一项上传')
          }
        } else {
          this.$message.error('所属分类和标签必须选择')
        }
      }
    },
  }
</script>

<style scoped>

</style>